/*
 * Copyright (c) 2017-present, flop! contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 * https://framagit.org/flopedt/flopedt
 */

import type { Preferences } from '@/ts/entities/preferences.ts'

import { defineStore } from 'pinia'
import { ref } from 'vue'

// TODO: add more things to this lonely store..!
export const usePrefsStore = defineStore('prefs', () => {
  const preferences = ref<Preferences | null>(null)

  return {
    preferences,
  }
})
